const getBaseUrl = () => {
  if (
    typeof window !== 'undefined' &&
    window.location?.hostname === 'dashboard.easyllama.local'
  ) {
    return 'http://api.easyllama.local:3000';
  }

  return process.env.REACT_APP_API_BASE_URL || 'https://api.easyllama.com';
}

const BASE_URL = getBaseUrl();

const getLearnerBaseUrl = () => {
  if (
    typeof window !== 'undefined' &&
    window.location?.hostname === 'dashboard.easyllama.local'
  ) {
    return 'http://l.easyllama.local:3000';
  }

  return process.env.REACT_APP_LEARNER_BASE_URL || 'https://l.easyllama.com';
}

const LEARNER_BASE_URL = getLearnerBaseUrl();

/**
 * PostHog session replay: add this class to any element that displays PII
 * (name, email, phone, address) so it is not captured in recordings.
 * @see https://posthog.com/docs/session-replay/privacy
 */
export const PH_NO_CAPTURE_CLASS = 'ph-no-capture';

export { BASE_URL, LEARNER_BASE_URL };
